export const getDateString = (): string => {
  return new Date().toISOString();
};
